import { getUser } from "hooks/storageUtils";
import DesignsystemsTableRaw from "./DesignsystemsTableRaw";

const DesignsystemsTable = ({ data, setDesignSystems }) => {
  const user = getUser();
  // const designSystems = user?.design_systems?.filter(
  //   (ds) => ds.admin_id === user.id
  // );
  return (
    <div className='plt-settings-table'>
      <div className='plt-table-wrapper'>
        {/* Team */}
        <div className='plt-table-container'>
          <table className='plt-table plt-table-designsystem'>
            <thead>
              <tr>
                <th className='plt-table-head'>Name</th>
                <th className='plt-table-head'>URL</th>
                <th className='plt-table-head'>Access</th>
                <th className='plt-table-head'>Owner</th>
                <th className='plt-table-head'>Privacy</th>
                <th className='plt-table-head'></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((designSystem, index) => (
                <DesignsystemsTableRaw
                  key={designSystem.id}
                  row={designSystem}
                  slno={index + 1}
                  setDesignSystems={setDesignSystems}
                  // designSystems={designSystems}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DesignsystemsTable;
